import React from 'react';
import { css } from '@emotion/react';
import { useReactToPrint } from 'react-to-print';

export const usePrint = (onPrinting?: ((isPrinting: boolean) => void) | undefined) => {
  const printRef = React.useRef<HTMLDivElement>(null);
  usePrintStyles();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforePrint: () => {
      onPrinting?.(true);
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          resolve();
        }, 100);
      });
    },
    onAfterPrint: () => {
      onPrinting?.(false);
    },
    onPrintError: () => {
      onPrinting?.(false);
    },
  });

  return { printRef, handlePrint };
};

const usePrintStyles = () => {
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          margin: 6mm 4mm;
        }     
        body {
          zoom: 0.75 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .print-container {
          position: relative !important;
          width: 1280px;
          height: auto;
          overflow: visible;
          background: white;
          box-shadow: none;
        }

        .page {
          page-break-before: always;
          page-break-inside: avoid;
        }

        canvas {
          width: auto !important;
          height: auto !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
};
